<div class="wf-section">
  <div>
    <h1 class="heading-16"> </h1>
  </div>
</div>
<div>
  <div class="wf-section">
    <div class="columns1 w-row">
      <h5 class="heading">Términos y condiciones de uso‍</h5>
      <p class="paragraph">Al crear un usuario en {{sitio}}, ingresar y utilizar este sistema, Usted estará aceptando
        los
        siguientes términos y condiciones: <br></p>
      <h5 class="heading izq">Proveedor:</h5>
      <p class="paragraph" [innerHTML]="proveedor"></p>
      <h5 class="heading izq">Uso de {{sitio}}:</h5>
      <p class="paragraph" [innerHTML]="funciones"></p>
      <h5 class="heading izq">Usuarios del sistema:</h5>
      <p class="paragraph" [innerHTML]="usuarios"></p>
      <h5 class="heading izq">Aspectos técnicos:</h5>
      <p class="paragraph" [innerHTML]="tecnica"></p>
      <h5 class="heading izq">Licencia de Uso:</h5>
      <p class="paragraph" [innerHTML]="licencia"></p>
      <h5 class="heading izq">Política de Privacidad:</h5>
      <p class="paragraph" [innerHTML]="privacidad"></p>
      <div *ngIf="this.sitio=='EasyMed'">
        <h5 class="heading izq">Política de Protección de Datos de Salud:</h5>
        <p class="paragraph" [innerHTML]="privacidadSalud"></p>
      </div>
      <h5 class="heading izq">Responsabilidad:</h5>
      <p class="paragraph" [innerHTML]="responsabilidad"></p>
      <h5 class="heading izq">Condiciones Comerciales:</h5>
      <p class="paragraph" [innerHTML]="comerciales"></p>
    </div>
  </div>